import React, { useState, useEffect } from 'react';

import LineChart from '../../components/LineChart/LineChart';
import LngArrivalsTable from './LngArrivalsTable/LngArrivalsTable';
import LngPricesTable from './LngPricesTable/LngPricesTable';
import Loader from '../../components/Loader/Loader';

import COLORS from '../../core/constants/colors';
import LngService from '../../core/services/lng-service';
import { LngModel } from '../../core/models/lng';

import './LngSection.scss';
import { LineChartModel } from '../../core/models/chart';
import Toggler from '../../components/Toggler/Toggler';
import ChartHints from '../../components/ChartHints/ChartHints';

const lngService = new LngService();

const togglerState = {
  mmbtu: '$/MMbtu',
  mwh: '€/MWh',
};

export default function LngSection(): JSX.Element {
  const [lngData, setLngData] = useState<LngModel>({} as LngModel);
  const [isLoading, setIsLoading] = useState(true);
  const [units, setUnits] = useState<string>(togglerState.mmbtu);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function toChartSeries(s: LineChartModel): any {
    return {
      ...s,
      dashStyle: s.marketName.includes('forward') ? 'Dash' : 'Solid',
    };
  }

  useEffect(() => {
    lngService.getLng().then((response) => {
      const transformedData = {
        ...response,
        chartGasPrices: response.chartGasPrices.map(toChartSeries),
      };
      setLngData(transformedData);
      setIsLoading(false);
    });
  }, []);

  const onToggle = (value: string): void => {
    setUnits(value);
  };

  return isLoading ? (
    <Loader />
  ) : (
    <div className="LngSection">
      <div className="total-container">
        <h2>
          <span>LNG</span>
        </h2>
        <div className="LngSection__content">
          <div className="mb-6">
            <LineChart
              title="Gas Prices"
              yAxisTitle="$/MMbtu"
              itemDistance={40}
              decimals={4}
              legend={{
                width: '70%',
                alignColumns: true,
              }}
              colors={[
                COLORS.orangeChart,
                COLORS.blueChart,
                COLORS.orangeChart,
                COLORS.blueChart,
                COLORS.red,
                COLORS.greenChart,
                COLORS.red,
                COLORS.greenChart,
                COLORS.purple,
              ]}
              data={[...lngData.chartGasPrices]}
            />
            <ChartHints />
          </div>

          <div className="row">
            <div className="col-md-6 mb-10">
              {lngData.arrivalsUKTable ? (
                <LngArrivalsTable data={[...lngData.arrivalsUKTable]} />
              ) : null}
            </div>
            <div className="col-md-6 mb-10">
              <h3>LNG & Gas Prices</h3>
              <div className="LngSection__toggler">
                <Toggler
                  leftText={togglerState.mmbtu}
                  rightText={togglerState.mwh}
                  handler={onToggle}
                />
              </div>
              {units === togglerState.mmbtu ? (
                <LngPricesTable
                  date1={lngData.lngPricesTable.date1}
                  date2={lngData.lngPricesTable.date2}
                  rows={lngData.lngPricesTable.pricesTableDollar}
                  units="$/MMbtu"
                />
              ) : (
                <LngPricesTable
                  date1={lngData.lngPricesTable.date1}
                  date2={lngData.lngPricesTable.date2}
                  rows={lngData.lngPricesTable.pricesTableEuro}
                  units="€/MWh"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
